import { render, staticRenderFns } from "./UpdateOneKidsConfigDialog.vue?vue&type=template&id=57717c4e&scoped=true"
import script from "./UpdateOneKidsConfigDialog.vue?vue&type=script&lang=js"
export * from "./UpdateOneKidsConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateOneKidsConfigDialog.vue?vue&type=style&index=0&id=57717c4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57717c4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57717c4e')) {
      api.createRecord('57717c4e', component.options)
    } else {
      api.reload('57717c4e', component.options)
    }
    module.hot.accept("./UpdateOneKidsConfigDialog.vue?vue&type=template&id=57717c4e&scoped=true", function () {
      api.rerender('57717c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/UpdateOneKidsConfigDialog.vue"
export default component.exports